import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { useOutofPolicySpendContext } from 'contexts/CategoryInsightsKpi/OutofPolicySpendProvider';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const OutofPolicySpendExplore = () => {
	const { gridData } = useOutofPolicySpendContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of suppliers that are not approved by the entity.`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default OutofPolicySpendExplore;
